module.exports = __webpack_public_path__ + "src/assets/img/buy.41bb0956.png";